import React, { createContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { printToast } from "../../../../../config/global";
import {
  getRealizadoProgramaByPlan72RealizadoAcao,
  salvarAvaliacaoPrograma,
} from "../../../../../service/Rag/AvaliacaoPrograma";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
export const AvaliacaoProgramaContext = createContext();

export const AvaliacaoProgramaProvider = ({ children, props }) => {
  const location = useLocation();
  const [campos, setCampos] = useState(
    JSON.parse(props?.questionario && props.questionario ? props.questionario : null)
  );

  const [dadosOrcamFinan, setDadosOrcamFinan] = useState([
    ...props.dadosItemPrograma?.dadosItemRag?.plan72RealizadoPrograma,
  ]);

  const [totalOrcamFinan, setTotalOrcamFinan] = useState({
    codgFonte: "Total",
    vlrInicial: 0,
    vlrAtualizado: 0,
    vlrSuplementado: 0,
    vlrAnulado: 0,
    vlrContigenciadoBloqueado: 0,
    vlrEmpenhado: 0,
    vlrLiquidado: 0,
    vlrPpd: 0,
    vlrCofd: 0,
    vlrLiquidadoInicial: 0,
    vlrLiquidadoFinal: 0,
  });

  let history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const varOrcFinan = (await buscarRealizadoProgramaByPlan72RealizadoAcao(props.dadosItemPrograma)) || [];

      const agrupadoPorFonte =
        varOrcFinan.length > 0
          ? varOrcFinan.reduce((acc, item) => {
              const { codgFonte } = item;

              if (!acc[codgFonte]) {
                acc[codgFonte] = { ...item };
              } else {
                acc[codgFonte].vlrInicial += item.vlrInicial;
                acc[codgFonte].vlrAtualizado += item.vlrAtualizado;
                acc[codgFonte].vlrSuplementado += item.vlrSuplementado;
                acc[codgFonte].vlrAnulado += item.vlrAnulado;
                acc[codgFonte].vlrContigenciadoBloqueado += item.vlrContigenciadoBloqueado;
                acc[codgFonte].vlrEmpenhado += item.vlrEmpenhado;
                acc[codgFonte].vlrLiquidado += item.vlrLiquidado;
                acc[codgFonte].vlrDotacaoAtualizada += item.vlrDotacaoAtualizada;
              }

              return acc;
            }, {})
          : {};
      const resultadoAgrupado = Object.values(agrupadoPorFonte).map((item) => {
        const vlrInicialValido = item.vlrInicial > 0 ? item.vlrInicial : null;
        const vlrAtualizadoValido = item.vlrAtualizado > 0 ? item.vlrAtualizado : null;
        const vlrAtualizadoAjustado =
          item.vlrAtualizado - item.vlrContigenciadoBloqueado > 0
            ? item.vlrAtualizado - item.vlrContigenciadoBloqueado
            : null;

        return {
          ...item,
          vlrPpd: vlrInicialValido ? (item.vlrEmpenhado / vlrInicialValido) * 100 : 0,
          vlrCofd: vlrAtualizadoAjustado ? (item.vlrEmpenhado / vlrAtualizadoAjustado) * 100 : 0,
          vlrLiquidadoInicial: vlrInicialValido ? (item.vlrLiquidado / vlrInicialValido) * 100 : 0,
          vlrLiquidadoFinal: vlrAtualizadoValido ? (item.vlrLiquidado / vlrAtualizadoValido) * 100 : 0,
        };
      });

      setDadosOrcamFinan(Object.values(resultadoAgrupado));

      var total = {
        codgFonte: "Total",
        vlrInicial: varOrcFinan.reduce((acc, current) => acc + parseFloat((current.vlrInicial || 0).toFixed(2)), 0),
        vlrAtualizado: varOrcFinan.reduce(
          (acc, current) => acc + parseFloat((current.vlrAtualizado || 0).toFixed(2)),
          0
        ),
        vlrSuplementado: varOrcFinan.reduce(
          (acc, current) => acc + parseFloat((current.vlrSuplementado || 0).toFixed(2)),
          0
        ),
        vlrAnulado: varOrcFinan.reduce((acc, current) => acc + parseFloat((current.vlrAnulado || 0).toFixed(2)), 0),
        vlrContigenciadoBloqueado: varOrcFinan.reduce(
          (acc, current) => acc + parseFloat((current.vlrContigenciadoBloqueado || 0).toFixed(2)),
          0
        ),
        vlrEmpenhado: varOrcFinan.reduce((acc, current) => acc + parseFloat((current.vlrEmpenhado || 0).toFixed(2)), 0),
        vlrLiquidado: varOrcFinan.reduce((acc, current) => acc + parseFloat((current.vlrLiquidado || 0).toFixed(2)), 0),
        vlrPpd: 0,
        vlrCofd: 0,
        vlrLiquidadoInicial: 0,
        vlrLiquidadoFinal: 0,
      };

      let vlrAtualizado = total.vlrAtualizado - total.vlrContigenciadoBloqueado;
      total.vlrPpd = total.vlrInicial !== 0 ? (total.vlrEmpenhado / total.vlrInicial) * 100 : 0;
      total.vlrCofd = vlrAtualizado !== 0 ? (total.vlrEmpenhado / vlrAtualizado) * 100 : 0;
      total.vlrLiquidadoInicial = total.vlrInicial !== 0 ? (total.vlrLiquidado / total.vlrInicial) * 100 : 0;
      total.vlrLiquidadoFinal = total.vlrAtualizado !== 0 ? (total.vlrLiquidado / total.vlrAtualizado) * 100 : 0;

      setTotalOrcamFinan(total);
    };

    fetchData();
  }, [props.dadosItemPrograma]);

  const buscarRealizadoProgramaByPlan72RealizadoAcao = async (dadosItemPrograma) => {
    if (dadosItemPrograma !== null) {
      let codgExercicio = dadosItemPrograma.dadosItemRag.exercicio.ano;

      let codgUo = location.state.data.unidadeOrcamentaria.codgUo;
      let codgPrograma = location.state.data.programa.codgPrograma;

      return getRealizadoProgramaByPlan72RealizadoAcao(codgExercicio, codgUo, codgPrograma).then((res) => {
        return res.data;
      });
    }

    return [];
  };

  const salvar = () => {
    let v_campos = campos.map((questao) => {
      questao.valrRespostaItemQuest = questao.data;

      // Verifica se a questão é obrigatória e está em branco
      if (questao.flagObrigatorio === "S" && !questao.valrRespostaItemQuest) {
        printToast({ severity: "error", detail: `Questão não pode ser salva em branco: ${questao.descPergunta}` });
        throw new Error(`Questão obrigatória em branco: ${questao.descPergunta}`);
      }

      return { ...questao };
    });

    let codigoItem = campos[0].codigoItemRag;

    salvarAvaliacaoPrograma(codigoItem, v_campos).then((res) => {
      props.setCamposQuestionarioExecucao(JSON.stringify(campos));
      props.aba(true); //Controle para sinalizar que a Aba Identificacao deve realizar a busca do percentual de preenchimento do programa
      printToast({ summary: "Ação Efetuada", detail: "Análise da execução salva com sucesso" });
    });
  };

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  return (
    <AvaliacaoProgramaContext.Provider
      value={{
        campos,
        setCampos,
        dadosOrcamFinan,
        totalOrcamFinan,
        salvar,
        voltar,
        condicao: props.condicao,
      }}
    >
      {children}
    </AvaliacaoProgramaContext.Provider>
  );
};
